<template>
  <v-content>
    <v-row no-gutters>
      <v-col cols="12">
        <v-flex class="pb-2 ml-0">
          <v-alert dense color="primary" class="text-left" text border="left"
            >PLANO DE CATEGORIAS</v-alert
          >
        </v-flex>
      </v-col>
    </v-row>

    <v-card v-show="!sv">
      <v-row no-gutters>
        <v-col cols="4">
          <v-text-field
            v-model="search"
            append-icon="search"
            label="Pesquisar"
            filled
            dense
            single-line
            hide-details
          ></v-text-field>
        </v-col>
        <v-col class="text-left" cols="4">
          <v-btn
            v-show="$can('categorias.create|admin.loja')"
            @click="novo()"
            color="topEnviados"
            dark
          >
            <v-icon>mdi-plus</v-icon>Nova
          </v-btn>
        </v-col>
      </v-row>
      <v-data-table
        :headers="headers"
        :items="itemsPlanos"
        :loading="loading_table"
        :footerProps="footerProps"
        loading-text="Carregando... Aguarde"
        dense
        :search="search"
        no-data-text="Nenhum resultado encontrado!"
        no-results-text="Nenhum resultado encontrado!"
        class="elevation-1"
      >
      <template v-slot:item.chk_ativo="{ item }">
          <v-switch
            v-show="$can('categorias.update|admin.loja')"
            dense
            color="green"
            :label="`${checkStatus(item.chk_ativo)}`"
            :true-value=1
            :false-value=0
            @change="
              mudarStatus(item.id, item.chk_ativo, 'chk_ativo')
            "
            v-model="item.chk_ativo"
            value
          ></v-switch>
        </template>
        <template v-slot:item.action="{ item }">
          <v-icon
            color="btBlue"
            class="mr-2"
            v-show="$can('categorias.update|admin.loja')"
            @click="editCategoria(item)"
            >edit</v-icon
          >
          <v-icon
            color="error"
            class="mr-2"
            v-show="$can('admin.loja|categorias.delete')"
            @click="deleteCategoria(item)"
            >delete</v-icon
          >
        </template>
      </v-data-table>
    </v-card>

    <v-dialog v-model="dialogCadastro" persistent max-width="45%">
      <v-card>
        <v-card-title class>
          <span v-if="cadastro">Cadastrar Plano Categoria</span>
          <span v-if="cadastro == false">Editar Plano Categoria</span>
        </v-card-title> 
        <v-card-text>
          <v-container>
            <v-col>
              <v-col cols="12" md="12" lg="12">
                <v-text-field
                  v-model="descricao"
                  label="Descrição"
                  filled
                  dense
                  clearable
                  required
                ></v-text-field>
              </v-col>
                <v-col cols="12"  lg="12" sd="12"  md="12" xs="6"  >
                  <div>
                    <v-select
                      v-model="dispositivos"
                      :items="itemsDispositivos"
                      label="Dispositivos"
                      item-text="descricao"
                      item-value="token"
                      class="text-md-left"
                     
                      clearable
                      dense
                      multiple
                      filled
                      required
                    ></v-select>
                  </div>
                </v-col>

                 <v-col cols="12"  lg="12" sd="12"  md="12" xs="6"  >
                  <div>
                    <v-select
                      v-model="SelCategorias"
                      :items="itemsCategoria"
                      label="Categorias"
                      item-text="descricao"
                      item-value="id"
                      class="text-md-left"
                     
                      clearable
                      dense
                      multiple
                      filled
                      required
                    ></v-select>
                  </div>
                </v-col>
              <!--<v-col cols="12" md="12" lg="12">
                <v-autocomplete
                  v-model="catSel"
                  :items="cats" 
                  filled
                  chips
                  color="blue-grey lighten-2"
                  label="Selecione uma imagem"
                  item-text="name"
                  item-value="codigo"
                >
                  <template v-slot:selection="data">
                    <v-chip
                      v-bind="data.attrs"
                      :input-value="data.selected"
                      close
                      @click="data.select"
                      @click:close="remove(data.item)"
                    >
                      <v-avatar left>
                        <img :src="data.item.avatar" />
                      </v-avatar>
                      {{ data.item.name }}
                    </v-chip>
                  </template>
                  <template v-slot:item="data">
                    <template v-if="typeof data.item !== 'object'">
                      <v-list-item-content
                        v-text="data.item"
                      ></v-list-item-content>
                    </template>
                    <template v-else>
                      <img :src="data.item.avatar" />

                      <v-list-item-content>
                        <v-list-item-title
                          v-html="data.item.name"
                        ></v-list-item-title>
                      </v-list-item-content>
                    </template>
                  </template>
                  <template v-slot:selection="data">
                    {{data.item.avatar}}
                    <v-chip
                      x-large
                      v-bind="data.attrs"
                      :input-value="data.selected"
                      close
                      label
                      @click="data.select"
                      @click:close="remove(data.item)"
                    >
                      <v-img :src="data.item.avatar"></v-img>
                      {{ data.item.name }}
                    </v-chip>
                  </template>
                  <template v-slot:item="data">
                    <template v-if="typeof data.item !== 'object'">
                      <v-list-item-content v-text="data.item"></v-list-item-content>
                    </template>
                    <template v-else>
                      <img :src="data.item.avatar" />

                      <v-list-item-content>
                        <v-list-item-title v-html="data.item.name"></v-list-item-title>
                      </v-list-item-content>
                    </template>
                  </template>
                </v-autocomplete>
              </v-col>-->
           
              </v-col>
             
          
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-col cols="12" md="6" lg="6">
            <v-btn color="error" @click="dialogCadastro = false">
              <v-icon>mdi-close</v-icon>Cancelar
            </v-btn>
          </v-col>

          <v-col cols="12" md="6" lg="6">
            <v-btn
              v-if="cadastro"
                :loading="gravando"
              color="success"
              class="mr-4"
              @click="gravar()"
            >
              <v-icon>mdi-check</v-icon>Gravar
            </v-btn>
            <v-btn
              v-if="cadastro == false"
              :loading="gravando"
              color="success"
              class="mr-4"
              @click="gravar()"
            >
              <v-icon>mdi-check</v-icon>Editar
            </v-btn>
          </v-col>
          <v-snackbar
      :timeout="5000"
      :color="error"
      :top="true"
      :multi-line="'multi-line'"
      :vertical="'vertical'"
      v-model="snackbarError"
    >
      {{ textSnack }}
      <v-btn text @click.native="snackbarError = false">X</v-btn>
    </v-snackbar>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-row justify="center">
      <v-dialog v-model="dialogCancel" persistent max-width="290">
        <v-card>
          <v-card-title class="headline">Excluir</v-card-title>
          <v-card-text>Deseja excluir essa Categoria?</v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="red darken-1"
              class="white--text"
              @click="dialogCancel = false"
              >Não</v-btn>
            <v-btn
              color="green darken-1"
              class="white--text"
              @click="deleta(selItem)"
              >Sim</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
    <v-snackbar
      :timeout="3000"
      :color="sucesso"
      :bottom="true"
      absolute
      :multi-line="'multi-line'"
      :vertical="'vertical'"
      v-model="snackbarSuccess"
    >
      {{ textSucesso }}
     
    </v-snackbar>

    <v-snackbar
      :timeout="5000"
      :color="error"
      :top="true"
      :multi-line="'multi-line'"
      :vertical="'vertical'"
      v-model="snackbarError"
    >
      {{ textSnack }}
      <v-btn @click.native="snackbarError = false">Fechar</v-btn>
    </v-snackbar>
  </v-content>
</template>

<script>
export default {
  props: {
    source: String,
  },
  mounted() {
    
    this.categorias();
    this.listaPlanos();
    this.buscaDispositivos();
    
  },
  data: () => ({
    SelCategorias:[],
    itemsDispositivos: [],
    dispositivos: [],
    cnpj: sessionStorage.getItem("cnpj"),
    cadastro: true,
    gravando:false,
    snackbarSuccess: false,
    snackbarError: false,
    snackbar: false,
    textSucesso: "",
    textSnack: "",
    sucesso: "botao_sucesso",
    error: "error",
    footerProps: { "items-per-page-options": [30, 50, 100] },
    singleLine: true,
   
    descricao: "",
    itemsPlanos: [],
      
    
    cats: [],
    name: "",
    autoUpdate: true,

    isUpdating: false,
    imageFile: [],
    file: "",
    files: "",

    filtroProduto: "Produtos ",
    sv: false,
    dialogCadastro: false,
    itensPorPagina: 25,
    itemsCategoria: [],
    itemsProdutosSgt: [],
    itemsProdutosSgtVinculados: [],
    search: "",
    searchVinculados: "",
    loading_table: false,
    selProduto: "",
    itemEdit: "",
    dialogCancel: false,
    selItem: "",
    catSel: "2",
    headers: [
      {
        text: "Código",
        align: "left",
        value: "id",
        width:"10%",
      },
      {
        text: "Plano",
        value: "descricao",
        sortable: true,
        align: "left",
          width:"70%",
      },
     
      { text: "Ação", width:"10%",  align: "right", value: "action", sortable: false },
    ],
  }),
  watch: {
    isUpdating(val) {
      if (val) {
        setTimeout(() => (this.isUpdating = false), 3000);
      }
    },
  },
 
  methods: {
    remove(item) {
      const index = this.catSel.indexOf(item.name);
      if (index >= 0) this.catSel.splice(index, 1);
    },
    novo() {
      this.dialogCadastro = true;
       //const maiorOrdem = Math.max(...this.itemsCategoria.map(categoria => categoria.ordem));
    //console.log("Maior ordem:", maiorOrdem);
      this.limpaCampos();
 
    },
    limpaCampos() {
      this.cadastro = true;
      this.descricao = "";
      this.dispositivos = "";
      this.categorias="";
      this.catSel = "";
    },
    fecharDialog() {},

    editCategoria(item) {
      this.dialogCadastro = true;
      this.cadastro = false;
      this.descricao  = item.descricao
      this.dispositivos = item.dispositivos
      this.SelCategorias = item.categorias
      this.itemEdit = item.id;
     
    },
    deleteCategoria(item) {
      this.selItem = item.id;
      this.dialogCancel = true;
    },

    deleta() {
      axios.post(`/categoria/deleta`, { id: this.selItem }).then((response) => {
        if (response.data.error) {
          this.textSnack = response.data.error;
          this.snackbarError = true;
        } else {
          this.snackbarSuccess = true;
          this.textSucesso = response.data.msg;
          this.dialogCancel = false;
          this.categorias();
        }
      });
    },
    buscaDispositivos() {
      axios.get(`/plano_categoria/lista_dispositivos/${this.cnpj}`).then((response) => {
        if (response.data.error) {
          //  this.textSnack = response.data.error;
          //  this.snackbar = true;
        } else {
          this.itemsDispositivos = response.data;
        }
      });
    },
     buscaUltimaOrdem(id_categoria) {
      axios.get(`/categoria/ultima_ordem/${id_categoria}`).then((response) => {
        if (response.data.error) {
          //  this.textSnack = response.data.error;
          //  this.snackbar = true;
        } else {
          this.categoria.ordem = response.data.ordem + 1;
        }
      });
    },
    imgCategorias() {
      axios.get(`/categoria/padrao`).then((response) => {
        if (response.data.error) {
          //  this.textSnack = response.data.error;
          //  this.snackbar = true;
        } else {
          this.cats = response.data;
        }
      });
    },
    listaPlanos() {
      axios.get(`/plano_categoria/lista/`).then((response) => {
        if (response.data.error) {
          //  this.textSnack = response.data.error;
          //  this.snackbar = true;
        } else {
          this.itemsPlanos = response.data;
        }
      });
    },
    categorias() {
      this.loading_table = true;
      axios.get(`/categoria/lista`).then((response) => {
        if (response.data.error) {
          //  this.textSnack = response.data.error;
          //  this.snackbar = true;
        } else {
          this.loading_table = false;
          this.itemsCategoria = response.data;
        }
      });
    },
    async gravar() {
      this.gravando= true;
      await axios
        .post(`/plano_categoria/gravar`,{'id':this.itemEdit,'descricao': this.descricao, 'dispositivos':this.dispositivos 
          , categorias: this.SelCategorias 
         } )
        .then((response) => {
          if (response.data.error) {
            //  this.textSnack = response.data.error;
            //  this.snackbar = true;
          } else {
            //this.buscaProdutosSgt();
            this.snackbarSuccess = true;
            this.textSucesso = "Dados gravados com sucesso!";
            this.limpaCampos();
            this.dialogCadastro = false;
            this.listaPlanos();
            //this.categoria.descricao = "";
            //this.categoria.ordem = "";

//  this.novo();
          //  this.categorias();
          }
        })
        .catch((e) => {
          if (e.response.data != undefined) {
            if (!Array.isArray(e.response.data)) {
              let itens = [];
              for (var prop in e.response.data) {
                itens.push(e.response.data[prop][0]);
              }
              this.textSnack = itens.join(" ");
              this.snackbarError = true;
            } else {
              this.textSnack = e.response.error;
              this.snackbarError = true;
            }
          }
        });
        this.gravando= false
    },
    async gravarEdicao() {
      this.gravando= true;
      let config = { headers: { "Content-Type": 'multipart/form-data' } };
      var formData = new FormData();

      var imagefile = document.querySelector("#avatar");
      formData.append("image", this.imageFile);

      formData.append("codigo_img", this.catSel);
      formData.append("ordem", this.categoria.ordem);
      formData.append("id", this.categoria.id);
      formData.append("descricao", this.categoria.descricao);

      await axios
        .post(`/categoria/editar`, formData, config)
        .then((response) => {
          if (response.data.error) {
            //  this.textSnack = response.data.error;
            //  this.snackbar = true;
          } else {
            //this.buscaProdutosSgt();
            this.snackbarSuccess = true;
            this.textSucesso = response.data.msg;
            this.limpaCampos();
            this.dialogCadastro = false;
            this.categorias();
          }
        })
        .catch((e) => {
          if (!Array.isArray(e.response.data)) {
            let itens = [];
            for (var prop in e.response.data) {
              itens.push(e.response.data[prop][0]);
            }
            this.textSnack = itens.join(" ");
            this.snackbar = true;
          } else {
            this.textSnack = e.response.error;
            this.snackbar = true;
          }
        });

        this.gravando = false
    },
    checkStatus(valor) {
      if (valor) {
        return "ativo";
      } else {
        return "suspenso";
      }
    },

    mudarStatus(id, status, tipo) {
      axios
        .post(`/adm/categoria/status`, { id: id, status: status, tipo: tipo })
        .then((response) => {
          if (response.data.error) {
            //  this.textSnack = response.data.error;
            //  this.snackbar = true;
          } else {
            this.snackbarSuccess = true;
            this.textSucesso = "Status alterado!";
            this.buscaProdutos();
          }
        });
    },
    buscaProdutos() {
      axios.get(`/adm/produto/lista`).then((response) => {
        if (response.data.error) {
          //  this.textSnack = response.data.error;
          //  this.snackbar = true;
        } else {
          // this.loading_table = false;
          //this.loading_filtrar = false;
          this.itemsProdutos = response.data;
        }
      });
    },
  },
};
</script>
<style scoped>
.v-input--selection-controls {
  padding: 5px !important;
  margin-bottom: 5px !important;
  margin-top: 16px;
  padding-top: 4px;
}
.v-data-table td {
  font-size: 0.685rem !important;
}
</style>
